import { useReducer } from "react";
import embLabels from "../config/emb-labels-en.json";

const getLineAndBusLength = (projectKind, switchType, count) => {
  let lineLength = 0;
  let busLength = 0;
  const { evCount, loadCount, derCount, remoteLoadCount } = count;

  const isExistingSwitchboard = switchType === embLabels.EXISTING_SWITCHBOARD;
  const isNewSwitchboard = switchType === embLabels.NEW_SWITCHBOARD;

  if (projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland ||projectKind?.isMGaaSETOGensetPvHybrid ) {
    if (isExistingSwitchboard) {
      if (derCount === 2) {
        lineLength = 100;
        busLength = 400;
      } else if(derCount ===3 ){
        lineLength = 945;
        busLength = 430;
      }  else if (derCount === 4) {
        lineLength = 970;
        busLength = 450;
      } 
      else if (derCount === 5) {
        lineLength = 1110;
        busLength = 590;
      } 
      else if ( derCount === 6 ) {
        lineLength = 1160;
        busLength = 650;
      } 
     

     
    } 
    else if (isNewSwitchboard) {
      if (derCount === 6) {
        lineLength = 1120;
        busLength = 830;
      } else if (derCount === 5) {
        lineLength =  projectKind?.isMGaaSETOIsland?1000:1050;
        busLength =  projectKind?.isMGaaSETOIsland?700:750;
      } else if (derCount === 4 ) {
        lineLength = projectKind?.isMGaaSETOIsland? 900:920;
        busLength = projectKind?.isMGaaSETOIsland?600:650;
      } if ( derCount === 3) {
        lineLength = 800;
        busLength =  projectKind?.isMGaaSETOIsland?510:500;
      } 
    }
  }

  return { lineLength, busLength };
};
export const coOrdinateValidator = (
  coOrdinates,
  switchType,
  siteType,
  projectTypeValue,
  count,
  rectangleWidth,
  loadSide = "",
  clientType,
  mode="",
  projectKind,
) => {

  let {
    x11,
    y11,
    y21,
    x12,
    y22,
    y12,
    x21,
    x22,
    svgevx0,
    svgevy0,
    svgldx0,
    svgldy0,
    svgldx1,
    svgldy1,
    svgldx2,
    svgldy2,
    svgldx3, 
    svgldy3,
    svgldx4,
    svgldy4,
    svgldx5, 
    svgldy5,
    svgldx6,
    svgldy6,
    svgldx7, 
    svgldy7,
    svgldx8,
    svgldy8,
    svgldx9, 
    svgldy9,
    svgldx10,
    svgldy10,
    busStart,
    svgx,
    svgy,
    loadLine0,
    loadLine1,
    loadLine2,
    loadLine3,
    loadLine4,
    loadLine5,
    loadLine6,
    loadLine7,
    loadLine8,
    loadLine9,
  } = coOrdinates;
  if (
    siteType === embLabels.GRID_CONNECTED_GSX &&
    ((projectTypeValue === "DaaS ANSI" ||projectTypeValue === "DaaS ETO")||(projectTypeValue === 'ANSI | Buildings | Autogrid Flex' || projectTypeValue === 'ETO | Buildings | Autogrid Flex'))
  ) {
    if (switchType === embLabels.NEW_SWITCHBOARD) {
      if (count.derCount === 2) {
        x11 = 158;
        y11 = 280;
        x21 = 400;
        y21 = 280;
        x12 = 800;
        y12 = 470;
        x22 = 520;
        y22 = 470;
      }
      if (count.derCount === 3) {
        x11 = 158;
        y11 = 285;
        x12 = 530;
        y12 = 300;
        x21 = 100;
        y21 = 300;
        x22 = 100;
        y22 = 300;
        rectangleWidth = 550;
      }
      if (count.derCount === 4) {
        x11 = 158;
        y11 = 285;
        x12 = 660;
        y12 = 300;
        x21 = 100;
        y21 = 300;
        x22 = 100;
        y22 = 300;
        rectangleWidth = 680;
      }
      if (count.derCount === 5) {
        x11 = 158;
        y11 = 285;
        x12 = 800;
        y12 = 300;
        x21 = 100;
        y21 = 300;
        x22 = 100;
        y22 = 300;
        rectangleWidth = 815;
      }
    } else if (switchType === "EXISTING_SWITCHBOARD") {
      if (count.derCount === 2) {
        x11 = 120;
        y11 = 285;
        x21 = 400;
        y21 = 285;
        x12 = 800;
        y12 = 430;
        x22 = 555;
        y22 = 430;
        rectangleWidth = 450;
      }
      if (count.derCount === 3) {
        x11 = 120;
        y11 = 285;
        x12 = 900;
        y12 = 428; //const
        x21 = 330;
        y21 = 285;
        x22 = 555;
        y22 = 428;
        rectangleWidth = 470;
      }
      if (count.derCount === 4) {
        x11 = 120;
        y11 = 285;
        x12 = 1000;
        y12 = 428;
        x21 = 330;
        y21 = 285;
        x22 = 555;
        y22 = 428; //existing sb
        rectangleWidth = 600;
      }

      if (count.derCount === 5) {
        x11 = 120;
        y11 = 285;
        x12 = 1130;
        y12 = 428;
        x21 = 330;
        y21 = 285;
        x22 = 555;
        y22 = 428;
        rectangleWidth = 730;
      }
      if(count.loadCount>=5){
        x11 = 120;
        y11 = 300;
        x21 = 750;
        y21 = 300;
        x12 = 650;
        y12 = 300;
        x22 = 100;
        y22 = 300;
      }
      if(count.loadCount===10){
        x11 = 700;
        y11 = 300;
        x21 = 120;
        y21 = 300;
        rectangleWidth = 700;
      }
    }
  } else if (
    siteType === embLabels.ISLANDABLE_GSX &&
   ((projectTypeValue === "DaaS ANSI" ||projectTypeValue === "DaaS ETO")||(projectTypeValue === 'ANSI | Buildings | Autogrid Flex' || projectTypeValue === 'ETO | Buildings | Autogrid Flex'))
  ) {
    if (switchType === embLabels.NEW_SWITCHBOARD) {
      if (count.derCount === 3) {
        x11 = 650;
        y11 = 300;
        x21 = 110;
        y21 = 300;
        rectangleWidth = 650
        if(count.loadCount>=5){
          x11 = 700;
          y11 = 300;
          x21 = 110;
          y21 = 300;
          rectangleWidth = 720
        }
        if(count.loadCount===10){
          x11 = 700;
          y11 = 300;
          x21 = 120;
          y21 = 300;
          rectangleWidth = 720;
        }
      }
      if (count.derCount === 4) {
        x11 = 650;
        y11 = 300;
        x21 = 110;
        y21 = 300;
        rectangleWidth = 675;
        // if(count.loadCount>=5){
        //   x11 = 750;
        //   y11 = 300;
        //   x21 = 110;
        //   y21 = 300;
        //   rectangleWidth = 750
        // }
        // if(count.loadCount===10){
        //   x11 = 800;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 800;
        // }
      }
      if (count.derCount === 5) {
        x11 = 750;
        y11 = 300;
        x21 = 110;
        y21 = 300;
        rectangleWidth =775;
        // if(count.loadCount>=5){
        //   x11 = 750;
        //   y11 = 300;
        //   x21 = 110;
        //   y21 = 300;
        //   rectangleWidth = 790
        // }
        // if(count.loadCount===10){
        //   x11 = 800;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 800;
        // }
      }
      if (count.derCount === 6) {
        x11 = 900;
        y11 = 300;
        x21 = 110;
        y21 = 300;
        rectangleWidth = 910;
        // if(count.loadCount>=5){
        //   x11 = 900;
        //   y11 = 300;
        //   x21 = 110;
        //   y21 = 300;
        //   rectangleWidth = 900
        // }
        // if(count.loadCount===10){
        //   x11 = 900;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 900;
        // }
      }
    } else if (switchType === "EXISTING_SWITCHBOARD") {            
      if (count.derCount === 3) {
        x11 = 70;
        y11 = 285;
        x12 = 1000;
        y12 = 428; //const
        x21 = 410;
        y21 = 285;
        x22 = 555;
        y22 = 428;
        rectangleWidth =  555;
        // rectangleWidth =  count.loadCount >=5 ? 670 : 555;
        // if(count.derCount>=2&&count.loadCount>=5){
        //   x12 = 1130;
        //   y12 = 428;
        //   x22 = 570;
        //   y22 = 428;
        //   rectangleWidth = count.loadCount >=5 ? 670 : 650
        // }
        // if(count.loadCount===10){
        //   x12 = 1150;
        //   y12 = 428;
        //   x22 = 570;
        //   y22 = 428;
        //   rectangleWidth =  count.loadCount >=5 ? 670 : 650;
        // }
      }
      if (count.derCount === 4) {
        x11 = 70;
        y11 = 285;
        x12 = 1020;
        y12 = 428;
        x21 = 370;
        y21 = 285;
        x22 =   555;
        y22 = 428; //existing sb
        rectangleWidth =  540;
        // rectangleWidth =count.loadCount >=5 ? 670 : 600;
        // if(count.derCount>=2&&count.loadCount>=5){
        //   x12 = count.loadCount>5 ? 1250 : 1130;
        //   y12 = 428;
        //   x22 = count.loadCount>=5 ? 555 : 570;
        //   y22 = 428;
        //   rectangleWidth = count.loadCount >5 ? 800 : 710
        // }
        // if(count.loadCount>=6){
        //   rectangleWidth = 790;
        // }
        // if(count.loadCount===10){
        //   x12 = 1230;
        //   y12 = 428;
        //   x22 = count.loadCount>=5 ? 555 : 570;
        //   y22 = 428;
        //   rectangleWidth = 790;
        // }
      }

      if (count.derCount === 5) {
        x11 = 70;
        y11 = 285;
        x12 = 1130;
        y12 = 428;
        x21 = 400;
        y21 = 285;
        x22 = 555;
        y22 = 428;
        rectangleWidth =  650;
        // rectangleWidth = count.loadCount >=5 ? 670 : 650;
        // if(count.derCount>=2&&count.loadCount>5){
        //   // x11 = 120;
        //   // y11 = 300;
        //   // x21 = 750;
        //   // y21 = 300;
        //   x12 = count.loadCount>=5 ?1250 : 1130;
        //   y12 = 428;
        //   x22 = count.loadCount>=5 ? 555 : 570;
        //   y22 = 428;
        //   rectangleWidth = count.loadCount >=5 ? 800 : 600
        // }
        // if(count.loadCount >=6){
        //   x12 = 1250;
        //   rectangleWidth = 790;
        // }
        // if(count.loadCount===10){
        //   x12 = 1250;
        //   y12 = 428;
        //   x22 = count.loadCount>=5 ? 555 :  570;
        //   y22 = 428;
        //   rectangleWidth = 790;
        // }
      }
      if (count.derCount === 6) {
        x11 = count.remoteLoadCount ? 70 : 80;
        y11 = 285;
        x12 = 1250;
        y12 = 428;
        x21 = 400;
        y21 = 285;
        x22 =  555;
        // x22 = count.loadCount>=5 ? 555 :  555;
        y22 = 428;
        rectangleWidth = 770;
        // if(count.loadCount>=5){
        //   x12 = 1250;
        //   y12 = 428;
        //   x22 = 555;
        //   y22 = 428;
        //   rectangleWidth = 800
        // }
        // if(count.loadCount===10){
        //   x12 = 1250;
        //   y12 = 428;
        //   x22 = 555;
        //   y22 = 428;
        //   rectangleWidth = 800;
        // }
      }    
    }
  } else if (
    siteType === embLabels.GRID_CONNECTED_GSX &&
    (projectTypeValue === "DaaS IEC"||projectTypeValue === 'IEC | Buildings | Autogrid Flex')
  ) {
    if (switchType === embLabels.NEW_SWITCHBOARD) {
      if (count.derCount === 3) {
        x12 = 120;
        y12 = 300;
        x22 = 500;
        y22 = 300;
        rectangleWidth = 550;
      }
      if (count.derCount === 4) {
        x12 = 120;
        y12 = 300;
        x22 = 650;
        y22 = 300;
        rectangleWidth = 670;
      }
    } else if (switchType === "EXISTING_SWITCHBOARD") {
      if (count.derCount === 3) {
        x11 = 120;
        y11 = 285;
        x12 = 900;
        y12 = 428; //const
        x21 = 330;
        y21 = 285;
        x22 = 450;
        y22 = 428;
        rectangleWidth = 550;
      }
      if (count.derCount === 4) {
        x11 = 120;
        y11 = 285;
        x12 = 1000;
        y12 = 428;
        x21 = 330;
        y21 = 285;
        x22 = 450;
        y22 = 428;
        rectangleWidth = 650;
      }

      if (count.derCount === 5) {
        x11 = 120;
        y11 = 285;
        x12 = 1130;
        y12 = 428;
        x21 = 430;
        y21 = 285;
        x22 = 570;
        y22 = 428;
        rectangleWidth = 700;
      }
      if (count.derCount === 6) {
        x11 = 120;
        y11 = 285;
        x12 = 1200;
        y12 = 428;
        x21 = 430;
        y21 = 285;
        x22 = 570;
        y22 = 428;
        rectangleWidth =  800;
      }
    }
  } else if (
    siteType === embLabels.ISLANDABLE_GSX &&
    (projectTypeValue === "DaaS IEC"||projectTypeValue === 'IEC | Buildings | Autogrid Flex')
  ) {
    if (switchType === embLabels.NEW_SWITCHBOARD) {
      if (count.derCount === 3) {
        x11 = 120;
        y11 = 300;
        x21 = 650;
        y21 = 300;
        rectangleWidth = 550;
        // if(count.loadCount>=5){
        //   x11 = 700;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 700
        // }
        // if(count.loadCount===10){
        //   x11 = 700;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 700;
        // }
      }
      if (count.derCount === 4) {
        x11 = 120;        
        y11 = 300;
        x21 = 650;
        y21 = 300;
        rectangleWidth = 670;
        // if(count.loadCount>=5){
        //   x11 = 750;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 750
        // }
        // if(count.loadCount===10){
        //   x11 = 800;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 800;
        // }
      }
      if (count.derCount === 5) {
        x11 = 120;        
        y11 = 300;
        x21 = 740;
        y21 = 300;
        rectangleWidth = 760;
        // if(count.loadCount>=5){
        //   x11 = 750;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 750
        // }
        // if(count.loadCount===10){
        //   x11 = 800;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 800;
        // }
      }
    } else if (switchType === "EXISTING_SWITCHBOARD") {
      if (count.derCount === 3) {
        x11 = 120;
        y11 = 285;
        // x12 = count.loadCount > 4 ?  count.loadCount > 5 ? 1250 : 1130 : 900;
        x12 = 900;
        y12 = 428; //const
        x21 = 410;
        y21 = 285;
        x22 = 510;
        y22 = 428;
        // rectangleWidth =  count.loadCount > 4 ?  count.loadCount > 5 ? 800 : 650 :450;
        rectangleWidth =  450;

      }
      if (count.derCount === 4) {
        x11 = 120;
        y11 = 285;
        // x12 =  count.loadCount > 4 ?  count.loadCount > 5 ? 1250 : 1130 : 1000;
        x12 =  1000;
        y12 = 428;
        x21 = 410;
        y21 = 285;
        x22 = 510;
        y22 = 428;
        // rectangleWidth =count.loadCount > 4 ?  count.loadCount > 5 ? 800 : 650 : 550;
        rectangleWidth = 550;
      }

      if (count.derCount === 5) {
        x11 = 120;
        y11 = 285;
        // x12 =  count.loadCount > 4 ?  count.loadCount > 5 ? 1250 : 1130 : 1060;
        x12 =  1060;
        y12 = 428;
        x21 = 410;
        y21 = 285;
        x22 = 510;
        y22 = 428;
        // rectangleWidth = count.loadCount > 4 ?  count.loadCount > 5 ? 800 : 650 : 650
        rectangleWidth =  650
      }
      if (count.derCount === 6) {
        x11 = 120;
        y11 = 285;
        x12 = 1250;
        y12 = 428;
        x21 = 410;
        y21 = 285;
        x22 = 510;
        y22 = 428;
        // rectangleWidth = count.loadCount > 4 ?  count.loadCount > 5 ? 800 : 650  : 700;
        rectangleWidth =  700;

      }
      // if(count.derCount >=2&&count.loadCount===10){
      //   x12 = 1250;
      //   y12 = 428;
      //   x22 = 510;
      //   y22 = 428;
      //   rectangleWidth = count.loadCount > 4 ?  count.loadCount > 5 ? 800 : 650  : 700;
      // }
    }
  } else if (
   ( siteType === embLabels.GRID_CONNECTED || siteType === embLabels.PV_HYBRIDIZATION)  &&
    (projectTypeValue === "MGaaS IEC"|| projectTypeValue === 'IEC | Buildings | Microgrid Advisor' ||projectTypeValue ==="MGaaS ETO" || projectTypeValue === 'ETO | Buildings | Microgrid Advisor'||projectTypeValue ==="NMGaaS ETO" || projectTypeValue === 'ETO | Buildings | New Microgrid Advisor')
  ) {
    if (switchType === embLabels.NEW_SWITCHBOARD) {
      const yPosition = siteType === embLabels.PV_HYBRIDIZATION?400:370;
      if (count.derCount === 2) {
        x11 = 400;
        y11 = yPosition;
        x21 = 700;
        y21 = yPosition;
        rectangleWidth = 380;
      }
      if (count.derCount === 3) {
        x11 = 400;
        y11 = yPosition;
        x21 = 800;
        y21 = yPosition;
        rectangleWidth = siteType === embLabels.PV_HYBRIDIZATION?570:500;
      }
      if (count.derCount === 4) {
        x11 = 400;
        y11 = yPosition;
        x21 = 930;
        y21 = yPosition;
        rectangleWidth = siteType === embLabels.PV_HYBRIDIZATION? 690 :620;
      }
      if (count.derCount === 5) {
        x11 = 400;
        y11 = yPosition;
        x21 = 1050;
        y21 = yPosition;
        rectangleWidth = siteType === embLabels.PV_HYBRIDIZATION?810: 730;
      }
    } else if (switchType === "EXISTING_SWITCHBOARD") {
      if (count.derCount === 2) {
        x11 = 120;
        y11 = 285;
        x21 = 360;
        y21 = 285;
        x12 = 850;
        y12 = 470;
        x22 = 620;
        y22 = 470;
        rectangleWidth = 350;
      }
      if (count.derCount === 3) {
        x11 = 120;
        y11 = 285;
        x21 = 360;
        y21 = 285;
        x12 = 930;
        y12 = 470;
        x22 = 620;
        y22 = 470;
        rectangleWidth =450;
      }
      if (count.derCount === 4) {
        x11 = 120;
        y11 = 285;
        x21 = 360;
        y21 = 285;
        x12 = 1050;
        y12 = 470;
        x22 = 620;
        y22 = 470;
        rectangleWidth = 500;
      }
      if (count.derCount === 5) {
        x11 = 120;
        y11 = 285;
        x21 = 360;
        y21 = 285;
        x12 = 1120;
        y12 = 470;
        x22 = 620;
        y22 = 470;
        rectangleWidth = 600;
      }
    }
  } else if (
    siteType === embLabels.GRID_CONNECTED &&
    (projectTypeValue === "MGaaS ANSI"||projectTypeValue === 'ANSI | Buildings | Microgrid Advisor')
  ) {
    if (switchType === embLabels.NEW_SWITCHBOARD) {
      if (count.derCount === 2) {
        x12 = 800;
        y12 = 470;
        x22 = 620;
        y22 = 470;
        rectangleWidth = 550;
      }
      if (count.derCount === 3) {
        x12 = 100;
        y12 = 300;
        x22 = 520;
        y22 = 300;
        rectangleWidth = 540;
      }
      if (count.derCount === 4) {
        x12 = 100;
        y12 = 300;
          x22 =  projectKind?.isMgaasAnsiGrid?650:580;
        y22 = 300;
        rectangleWidth = projectKind?.isMgaasAnsiGrid?650:580;
      }
      if (count.derCount === 5) {
        x12 = 100;
        y12 = 300;
        x22 =  projectKind?.isMgaasAnsiGrid?770:650;
        y22 = 300;
        rectangleWidth =  projectKind?.isMgaasAnsiGrid?770:660;
      }
      if (count.derCount >= 6) {
        x12 = 100;
        y12 = 300;
        x22 = 780;
        y22 = 300;
        rectangleWidth = 780;
      }
    } else if (switchType === "EXISTING_SWITCHBOARD") {
      if (count.derCount === 2) {
        x11 = 120;
        y11 = 285;
        x21 = 400;
        y21 = 285;
        x12 = 800;
        y12 = 430;
        x22 = 555;
        y22 = 430;
        rectangleWidth = 450;
      }
      if (count.derCount === 3) {
        x11 = 120;
        y11 = 285;
        x12 = 900;
        y12 = 428; //const
        x21 = 330;
        y21 = 285;
        x22 = 555;
        y22 = 428;
        rectangleWidth = 470;
      }
      if (count.derCount === 4) {
        x11 = 120;
        y11 = 285;
        x12 =  projectKind?.isMgaasAnsiGrid?1000:900;
        y12 = 428;
        x21 = 330;
        y21 = 285;
        x22 = 555;
        y22 = 428; //existing sb
       rectangleWidth =  projectKind?.isMgaasAnsiGrid?600:480;
      }

       if (count.derCount === 5) {
        x11 = 120;
        y11 = 285;
        x12 =  projectKind?.isMgaasAnsiGrid?1120:1010;
        y12 = 428;
        x21 = 330;
        y21 = 285;
        x22 = 555;
        y22 = 428;
        rectangleWidth =  projectKind?.isMgaasAnsiGrid?690:600;
      }
      if (count.derCount > 5) {
        x11 = 120;
        y11 = 285;
        x12 = 1130;
        y12 = 428;
        x21 = 330;
        y21 = 285;
        x22 = 555;
        y22 = 428;
        rectangleWidth = 700;
      }
      // if(count.loadCount>=5){
      //   x11 = 120;
      //   y11 = 300;
      //   x21 = 750;
      //   y21 = 300;
      //   x12 = 650;
      //   y12 = 300;
      //   x22 = 100;
      //   y22 = 300;
      // }
      // if(count.loadCount===10){
      //   x11 = 700;
      //   y11 = 300;
      //   x21 = 120;
      //   y21 = 300;
      //   rectangleWidth = 700;
      // }
    }
  }else if(siteType === embLabels.ISLANDABLE&& 
    (projectTypeValue==="MGaaS ANSI"||projectTypeValue==='ANSI | Buildings | Microgrid Advisor')
    && clientType === "GENERIC" && mode === "NO_FUEL"){
      if (switchType === embLabels.NEW_SWITCHBOARD) {
        if (count.derCount === 2) {
          x11 = 100;
          y11 = 300;
          x21 = 650;
          y21 = 300;
          rectangleWidth = count.loadCount>=5 ? 760 : 650;
          if(count.loadCount>=5){
            x11 = 800;
            y11 = 300;
            x21 = 120;
            y21 = 300;
            rectangleWidth = 800
          }
          // if(count.loadCount===10){
          //   x11 = 800;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 800;
          // }
        }
        if (count.derCount === 3) {
          x11 = 100;
          y11 = 300;
          x21 = 550;
          y21 = 300;
          rectangleWidth = count.loadCount>=4 ?600: 580;
          // if(count.loadCount>=5){
          //   x11 = 550;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 600
          // }
          // if(count.loadCount===10){
          //   x11 = 800;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 600;
          // }
        }
        if (count.derCount === 4) {
          x11 = 100;
          y11 = 300;
          x21 = 650;
          y21 = 300;
          rectangleWidth = 670;
          // if((count.evCount+count.loadCount)>=6||count.loadCount>=5){
          //   x11 = 800;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 800
          // }
          // if((count.evCount+count.loadCount)===10||count.loadCount===10){
          //   x11 = 550;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 800;
          // }
        }
        if (count.derCount === 5) {
          x11 = 100;
          y11 = 300;
          x21 = 780;
          y21 = 300;
          rectangleWidth = 800;
          // if(count.loadCount>=5){
          //   x11 = 550;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 800
          // }
          // if(count.loadCount===10){
          //   x11 = 800;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 800;
          // }
        }
        if (count.derCount === 6) {
          x11 = 100;
          y11 = 300;
          x21 = 880;
          y21 = 300;
          rectangleWidth = 900;
          // if(count.loadCount>=5){
          //   x11 = 880;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 900
          // }
          // if(count.loadCount===10){
          //   x11 = 880;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 900;
          // }
        }
      } else if (switchType === "EXISTING_SWITCHBOARD") {
        if (count.derCount === 2) {
          x11 = 70;
          y11 = 285;
          x21 = 400;
          y21 = 285;
          x12 = 980;
          y12 = 430;
          x22 = 555;
          y22 = 430;
          rectangleWidth = 450;
          // if(count.loadCount>=5){
          //   x12 = 1130;
          //   y12 = 428;
          //   x22 = 555;
          //   y22 = 428;
          //   rectangleWidth = 600
          // }
          // if(count.loadCount===10){
          //   x12 = 1150;
          //   y12 = 428;
          //   x22 = 555;
          //   y22 = 428;
          //   rectangleWidth = 650;
          // }
        }
        if (count.derCount === 3) {
          x11 = 70;
          y11 = 285;
          x21 = 400;
          y21 = 285;
          x12 = 930;
          y12 = 430;
          x22 = 555;
          y22 = 430;
          rectangleWidth = 450;
          // rectangleWidth = count.loadCount> 5 ? 750:  550;
          // if(count.loadCount === 5){
          //   x12 = count.loadCount> 5 ?1250:1140;
          //   y12 = 428;
          //   x22 = 555;
          //   y22 = 428;
          //   rectangleWidth = 530;
          //   // rectangleWidth = count.loadCount>= 5 ? 700:  550;
          // }
          // if(count.loadCount>5){
          //   x12 = 1250;
          //   rectangleWidth = 530;
          //   // rectangleWidth = count.loadCount> 5 ? 800:  550;
          // }
      
        }
        if (count.derCount === 4) {
          x11 = 70;
          y11 = 285;
          x21 = 400;
          y21 = 285;
          x12 = 1000;
          y12 = 430;
          x22 = 560;
          y22 = 430;
          rectangleWidth = 540;
          // rectangleWidth = count.loadCount> 5 ?  750 : 600;
          // if(count.loadCount>=5){
          //   x12 = count.loadCount > 5 ?  1250 : 1150;
          //   y12 = 428;
          //   x22 = 555;
          //   y22 = 428;
          //   rectangleWidth = 700;
          //   // rectangleWidth = count.loadCount >5 ? 790 : 700
          // }
          // if(count.loadCount===10){
          //   x12 = 1250;
          //   y12 = 428;
          //   x22 = 555;
          //   y22 = 428;
          //   rectangleWidth = 790;
          // }
        }
        if (count.derCount === 5) {
          x11 = 70;
          y11 = 285;
          x21 = 400;
          y21 = 285;
          x12 = 1140;

          // x12 = count.loadCount>5?1250:1140;
          y12 = 430;
          x22 = 555;
          y22 = 430;
          rectangleWidth =660;
          
          // rectangleWidth =count.loadCount>5? 800:700;
        }
        if (count.derCount === 6) {
          x11 = 90;
          y11 = 285;
          x21 = 400;
          y21 = 285;
          x12 = 1200;
          y12 = 430;
          x22 = 555;
          y22 = 430;
          rectangleWidth = 740;
        }
      }
  }else if(siteType === embLabels.ISLANDABLE&& 
    (projectTypeValue==="MGaaS ANSI"||projectTypeValue==='ANSI | Buildings | Microgrid Advisor')
    && clientType === "GENERIC" && mode === "FUEL_ERASER"){
      if (switchType === embLabels.NEW_SWITCHBOARD) {
        if (count.derCount === 2) {
          x11 = 800;
          y11 = 470;
          x21 = 620;
          y21 = 470;
          rectangleWidth = 550;
        }
        if (count.derCount === 3) {
          x11 = 100;
          y11 = 300;
          x21 = 550;
          y21 = 300;
          rectangleWidth = 550;
          // if((count.evCount+count.loadCount)>=6||count.loadCount>=5){
          //   x11 = 800;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 800
          // }
        }
        if (count.derCount === 4) {
          x11 = 100;
          y11 = 300;
          x21 = 650;
          y21 = 300;
          rectangleWidth = 670;
          // if((count.evCount+count.loadCount)>=6||count.loadCount>=5){
          //   x11 = 800;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 800
          // }
          // if((count.evCount+count.loadCount)===10||count.loadCount===10){
          //   x11 = 800;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 800;
          // }
        }
        if (count.derCount === 5) {
          x11 = 100;
          y11 = 300;
          x21 = 780;
          y21 = 300;
          rectangleWidth = 800;
          // if(count.loadCount>=5){
          //   x11 = 800;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 800
          // }
          // if(count.loadCount===10){
          //   x11 = 800;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 800;
          // }
        }
        if (count.derCount === 6) {
          x11 = 100;
          y11 = 300;
          x21 = 880;
          y21 = 300;
          rectangleWidth = 900;
          // if(count.loadCount>=5){
          //   x11 = 880;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 900
          // }
          // if(count.loadCount===10){
          //   x11 = 880;
          //   y11 = 300;
          //   x21 = 120;
          //   y21 = 300;
          //   rectangleWidth = 900;
          // }
        }
      } else if (switchType === "EXISTING_SWITCHBOARD") {
        if (count.derCount === 2) {
          x11 = 70;
          y11 = 285;
          x21 = 400;
          y21 = 285;
          // x12 =count.loadCount >5 ? 1250 : 800;
          x12 = 800;

          y12 = 470;
          x22 = 620;
          y22 = 470;
          rectangleWidth = 350;
        }
        if (count.derCount === 3) {
          x11 = 70;
          y11 = 285;
          x21 = 400;
          y21 = 285;
          // x12 = count.loadCount >5 ? 1250 : 1000;
          x12 =  1000;

          y12 = 430;
          x22 = 555;
          y22 = 430;
          svgx = 0;
          svgy = -30;
          svgldx0 = 0;
          svgldy0 = 0;
          rectangleWidth = 530;
          // if(count.loadCount>=5){
          //   x12 = count.loadCount>= 6 ? 1250 : 1130;
          //   y12 = 428;
          //   x22 = 555;
          //   y22 = 428;
          //   rectangleWidth = count.loadCount >=5 ? 650 : 600
          // }
          // if(count.loadCount===10){
          //   x12 = count.loadCount >5 ? 1250 :1150;
          //   y12 = 428;
          //   x22 = 555;
          //   y22 = 428;
          //   rectangleWidth = count.loadCount >=5 ? 750 :  650;
          // }
        }
        if (count.derCount === 4) {
          x11 = count.remoteLoadCount? 65:70;
          y11 = 285;
          x21 = 400;
          y21 = 285;
          // x12 = count.loadCount >5 ? 1250 : 1000;
          x12 = 1000;

          y12 = 430;
          x22 = 555;
          y22 = 430;
          svgx = 0;
          svgy = -30;
          // rectangleWidth =  count.loadCount >=5 ? 750 :555;
          rectangleWidth = 530;

          // if(count.loadCount === 5){
          //   x12 = count.loadCount>= 6 ? 1250 : 1130;
          //   y12 = 428;
          //   x22 = 555;
          //   y22 = 428;
          //   rectangleWidth = count.loadCount >=5 ? 750: 670
          // }
          // if(count.loadCount >= 6){
          //   x12 =  1250 
            
          //   rectangleWidth = 800;
          // }
          // if(count.loadCount===10){
          //   x12 = count.loadCount >5 ? 1250 : 1150;
          //   y12 = 428;
          //   x22 = 555;
          //   y22 = 428;
          //   rectangleWidth = count.loadCount>=5 ? 750 :  650;
          // }
        }
        if (count.derCount === 5) {
          x11 = 70;
          y11 = 285;
          x21 = 400;
          y21 = 285;
          // x12 = count.loadCount >5 ? 1250 :  1120;
          x12 =  1120;

          y12 = 430;
          x22 = 555;
          y22 = 430;
          // rectangleWidth = count.loadCount >5 ? 800 : 650;
          rectangleWidth =  650;
          
          // if(count.loadCount>=5){
          //   x12 = count.loadCount >= 6 ? 1250 : 1130;
          //   y12 = 428;
          //   x22 = 555;
          //   y22 = 428;
          //   rectangleWidth =  count.loadCount >5 ? 800 : 650
          // }
          // if(count.loadCount===10){
          //   x12 = count.loadCount >5 ? 1250 : 1150;
          //   y12 = 428;
          //   x22 = 555;
          //   y22 = 428;
          //   rectangleWidth =  count.loadCount >5 ? 800 :650;
          // }
        }
        if (count.derCount === 6) {
          x11 = 70;
          y11 = 285;
          x21 = 400;
          y21 = 285;
          // x12 = count.loadCount >5 ? 1250 : 1200;
          x12 = 1200;

          y12 = 430;
          x22 = 555;
          y22 = 430;
          rectangleWidth = 740;
        }
      }
    }else if (
    siteType === embLabels.ISLANDABLE &&
    (projectTypeValue === "MGaaS ANSI"||projectTypeValue === 'ANSI | Buildings | Microgrid Advisor')
  ) {
    if (switchType === embLabels.NEW_SWITCHBOARD) {
      if (count.derCount === 2) {
        x11 = 800;
        y11 = 470;
        x21 = 620;
        y21 = 470;
        rectangleWidth = 550;
      }
      if (count.derCount === 3) {
        x11 = 100;
        y11 = 300;
        x21 = 550;
        y21 = 300;
        rectangleWidth = 550;
      }
      if (count.derCount === 4) {
        x11 = 100;
        y11 = 300;
        x21 = 650;
        y21 = 300;
        rectangleWidth = 670;
        // if((count.evCount+count.loadCount)>=6||count.loadCount>=5){
        //   x11 = 800;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 800
        // }
        // if((count.evCount+count.loadCount)===10||count.loadCount===10){
        //   x11 = 800;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 800;
        // }
      }
      if (count.derCount === 5) {
        x11 = 100;
        y11 = 300;
        x21 = 780;
        y21 = 300;
        rectangleWidth = 800;
        // if(count.loadCount>=5){
        //   x11 = 800;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 800
        // }
        // if(count.loadCount===10){
        //   x11 = 800;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 800;
        // }
      }
      if (count.derCount === 6) {
        x11 = 100;
        y11 = 300;
        x21 = 880;
        y21 = 300;
        rectangleWidth = 900;
        // if(count.loadCount>=5){
        //   x11 = 880;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 900
        // }
        // if(count.loadCount===10){
        //   x11 = 880;
        //   y11 = 300;
        //   x21 = 120;
        //   y21 = 300;
        //   rectangleWidth = 900;
        // }
      }
    } else if (switchType === "EXISTING_SWITCHBOARD") {
      if (count.derCount === 2) {
        x11 = 60;
        y11 = 285;
        x21 = 400;
        y21 = 285;
        x12 = 800;
        y12 = 470;
        x22 = 620;
        y22 = 470;
        rectangleWidth = 350;
      }
      if (count.derCount === 3) {
        x11 = 120;
        y11 = 285;
        x21 = 400;
        y21 = 285;
        x12 = 900;
        // x12 =count.loadCount > 5?1250: 900;
        y12 = 470;
        x22 = 620;
        y22 = 470;
        rectangleWidth = 350;
      }
      if (count.derCount === 4) {
        x11 = 60;
        y11 = 285;
        x21 = 400;
        y21 = 285;
        x12 =  1000;
        // x12 =count.loadCount > 5?1250: 1000;
        y12 = 430;
        x22 = 555;
        y22 = 430;
        rectangleWidth = 585;
        // if(count.loadCount>=5){
        //   x12 = count.loadCount > 5?1250:1110;
        //   y12 = 428;
        //   x22 = 555;
        //   y22 = 428;
        //   rectangleWidth = count.loadCount > 5?800:670 
        // }

        // if(count.loadCount===10){
        //   x12 =count.loadCount > 5?1250: 1150;
        //   y12 = 428;
        //   x22 = 555;
        //   y22 = 428;
        //   rectangleWidth = 800;
        // }
      }
      if (count.derCount === 5) {
        x11 = 70;
        y11 = 285;
        x21 = 400;
        y21 = 285;
        x12 = 1120;
        // x12 = count.loadCount > 5?1250:1120;
        y12 = 430;
        x22 = 555;
        y22 = 430;
        rectangleWidth = 680;
        // rectangleWidth =count.loadCount > 5?800: 680;
      }
      if (count.derCount === 6) {
        x11 = 70;
        y11 = 285;
        x21 = 400;
        y21 = 285;
        x12 = 1200;
        // x12 = count.loadCount > 5?1250:1200;
        y12 = 430;
        x22 = 555;
        y22 = 430;
        rectangleWidth = 740;
      }
    }
  }
   else if (siteType === embLabels.GENSET_PVBESS_A2E) {
    x11 = 400;
    y11 = 360;
    x21 = 850;
    y21 = 360;
    rectangleWidth = 530
  } else if(projectKind?.isMgaasIecIsland || projectKind?.isMGaaSETOIsland){
    if (switchType === embLabels.NEW_SWITCHBOARD) {
        x11 =  410;
        y11 = 370;
        x21 = getLineAndBusLength(projectKind, switchType, count)?.lineLength
        y21 = 370;
        rectangleWidth =getLineAndBusLength(projectKind, switchType, count)?.busLength
    } else if (switchType === "EXISTING_SWITCHBOARD") {
        x11 = 110;
        y11 = 270;
        x21 = count.evCount ? 350 : 380;
        y21 = 270;
        x12 =getLineAndBusLength(projectKind, switchType, count)?.lineLength
        y12 = 470;
        x22 = 580;
        y22 = 470;
        svgevx0 = 250
        svgevy0 = 0
        svgldx0 =250;
        svgldy0 = 0
        busStart = 550
        rectangleWidth = getLineAndBusLength(projectKind, switchType, count)?.busLength

    }
  }

  return {
    cooridinates: { x11, y11, x21, y21, x12, y12, x22, y22,    svgevx0,
      svgevy0,
      svgldx0,
      svgldy0,
      svgldx1,
      svgldy1,
      svgldx2,
      svgldy2,
      svgldx3, 
      svgldy3,
      svgldx4,
      svgldy4,
      svgldx5, 
      svgldy5,
      svgldx6,
      svgldy6,
      svgldx7, 
      svgldy7,
      svgldx8,
      svgldy8,
      svgldx9, 
      svgldy9,
      svgldx10,
      svgldy10,
      busStart,
      svgx,
      svgy,
      loadLine0,
      loadLine1,
      loadLine2,
      loadLine3,
      loadLine4,
      loadLine5,
      loadLine6,
      loadLine7,
      loadLine8,
      loadLine9,
    },
    rectangleWidth,
    loadSide,
  };
};